import * as actions from "../action.constants";

const requestJobs = (pageUrl) => ({
  type: actions.REQUEST_JOBS,
  pageUrl,
});

const saveJobs = (data) => ({
  type: actions.STORE_JOBS,
  payload: data,
});

const requestJob = (payload) => ({
  type: actions.REQUEST_JOB,
  payload,
});

const saveJob = (data) => ({
  type: actions.STORE_JOB,
  payload: data,
});

export {requestJobs, saveJobs, requestJob, saveJob};
